import type React from 'react';
import { useId, useMemo } from 'react';

import { Checkbox, FormControl, View } from '@zinc/ui';
import { cache } from 'tm3-core/cache';
export interface IProps {
  id?: string;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  errorText?: string;
  submitted?: boolean;
  label: React.ReactNode;
  style?: React.CSSProperties;
  value?: boolean | string | number;
  dataTestId?: string;

  onChange: (e: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
}

function BzCheckbox(props: IProps) {
  return <ZincCheckbox {...props} />;
}
function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
function ZincCheckbox(props: IProps) {
  const { label, dLabel, errorText, submitted, value, onChange, checked, dataTestId, ...other } =
    props;
  const computedLabel = useMemo(
    () => (dLabel ? (cache.dynamicLabels.GetLabel(dLabel)?.text ?? label ?? '') : label),
    [label, dLabel]
  );
  const id = useId();
  let selected = value;
  let hackValue = undefined;
  if (!isNullOrUndefined(checked)) {
    selected = Boolean(checked);
    hackValue = value?.toString();
  } else selected = Boolean(value);

  return (
    <View paddingBottom={2} paddingTop={2}>
      {/* don't like having to do this padding, but needed for legacy i think */}

      <FormControl>
        <Checkbox
          {...other}
          value={hackValue}
          name={computedLabel ?? id}
          checked={selected}
          onChange={(a) => {
            onChange(a.event, Boolean(a.checked));
          }}
          attributes={{
            'data-testid': dataTestId
          }}
        >
          {computedLabel}
        </Checkbox>
        {errorText && submitted && <FormControl.Error>{errorText}</FormControl.Error>}
      </FormControl>
    </View>
  );
}
export default BzCheckbox;
